// Контентный попап в рамках компонента welcome popup
// для роли "старожил"

const template = /* html */`
    <div class="flex-column items-start gap-1">
        <h3>Подтвердите емейл, иначе «Дадата» не заработает</h3>
        <span>
            Достаточно перейти по ссылке в письме, которое мы отправили 
            на [[ userEmail ]]. Если письмо не приходит, проверьте спам. 
        </span>
    </div>
`;

export default {
    template,
    inject: ["userEmail"],
    props: { showContacts: Boolean },
};
